import { useState } from 'react';
import { trustPoints, faqItems } from '@/mocks/home';

export default function TrustFaq() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="py-16 md:py-28 bg-background-100">
      <div className="w-full px-4 md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-14">
          <div className="lg:col-span-5">
            <span className="font-label text-xs tracking-[0.3em] text-primary-600">WHY TRUST US</span>
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mt-3 leading-snug">
              为什么值得先看这里
            </h2>
            <p className="text-sm md:text-base text-foreground-600 mt-4 leading-relaxed">
              我们唯一做的事情，是把分散在评论区的立场聚到一起。热闹照旧，但你不必再凭一条截图就下结论。
            </p>

            <div className="flex flex-col gap-5 mt-9">
              {trustPoints.map((point) => (
                <div key={point.title} className="flex items-start gap-4">
                  <span className="w-10 h-10 shrink-0 flex items-center justify-center rounded-lg bg-primary-500 text-background-50">
                    <i className={`${point.icon} text-lg`} />
                  </span>
                  <div>
                    <h3 className="font-heading text-base font-semibold text-foreground-950">
                      {point.title}
                    </h3>
                    <p className="text-sm text-foreground-600 mt-1.5 leading-relaxed">{point.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="lg:col-span-7">
            <div className="bg-background-50 border border-background-200/70 rounded-lg p-5 md:p-7">
              <h3 className="font-heading text-lg md:text-xl font-semibold text-foreground-950">
                常见问题
              </h3>
              <p className="text-sm text-foreground-500 mt-2">
                关于站队情况、舆论反转与公关动作，你可能想先问清楚的几件事。
              </p>

              <div className="mt-6">
                {faqItems.map((item, index) => {
                  const isOpen = openIndex === index;
                  return (
                    <div
                      key={item.q}
                      className={`border-b border-background-200/70 last:border-b-0 ${
                        isOpen ? 'bg-accent-50/60' : ''
                      }`}
                    >
                      <button
                        type="button"
                        onClick={() => setOpenIndex(isOpen ? null : index)}
                        className="w-full flex items-center justify-between gap-4 py-4 px-2 text-left cursor-pointer"
                      >
                        <span className="font-heading text-sm md:text-base font-semibold text-foreground-950">
                          {item.q}
                        </span>
                        <span className="w-7 h-7 shrink-0 flex items-center justify-center rounded-full border border-background-300/80 text-foreground-600">
                          <i className={isOpen ? 'ri-subtract-line' : 'ri-add-line'} />
                        </span>
                      </button>
                      {isOpen && (
                        <p className="text-sm text-foreground-600 leading-relaxed pb-5 px-2">
                          {item.a}
                        </p>
                      )}
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}